var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "trainings",
              label: _vm.$t("online"),
              icon: "fal fa-globe"
            },
            slot: "title"
          }),
          _vm.hasPresential
            ? _c("q-route-tab", {
                attrs: {
                  slot: "title",
                  name: "presential",
                  label: _vm.$t(_vm.title_presential),
                  icon: "fal fa-users-class",
                  to: { name: "presential" }
                },
                slot: "title"
              })
            : _vm._e(),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-md q-pb-xl q-mt-md",
              attrs: { name: "trainings" }
            },
            [
              _c("div", { staticClass: "row gutter-md" }, [
                _c(
                  "div",
                  { class: _vm.filterClass },
                  [
                    _c("filter-courses", {
                      on: { changeFilter: _vm.changeFilter }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    class: _vm.contentClass,
                    staticStyle: { "min-height": "700px" }
                  },
                  [
                    _vm.banners.length > 0
                      ? _c(
                          "div",
                          { staticClass: "col-12 desktop-only q-mb-lg" },
                          [
                            _c(
                              "q-carousel",
                              {
                                staticClass: "text-white",
                                attrs: {
                                  height: "200px",
                                  infinite: "",
                                  autoplay: ""
                                }
                              },
                              _vm._l(_vm.banners, function(banner, index) {
                                return _c("q-carousel-slide", {
                                  key: index,
                                  attrs: { "img-src": banner.image_desktop }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.banners.length > 0 && _vm.showBanner
                      ? _c(
                          "div",
                          { staticClass: "col-12 mobile-only q-mb-lg" },
                          [
                            _c(
                              "q-carousel",
                              {
                                staticClass: "text-white",
                                attrs: {
                                  height: _vm.getHeight + "px",
                                  infinite: "",
                                  autoplay: ""
                                }
                              },
                              _vm._l(_vm.banners, function(banner, index) {
                                return _c("q-carousel-slide", {
                                  key: index,
                                  attrs: { "img-src": banner.image_mobile }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "q-infinite-scroll",
                      {
                        ref: "course_scroll",
                        attrs: { handler: _vm.loadCourses, offset: 10 }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row gutter-md" },
                          [
                            _vm._l(_vm.courses, function(course, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "col-xs-12 col-sm-12"
                                },
                                [
                                  _vm.$q.platform.is.desktop
                                    ? _c("card-desktop", {
                                        key: course.id,
                                        attrs: { course: course },
                                        on: {
                                          clickLike: _vm.clickLike,
                                          clickStars: _vm.clickStars,
                                          clickFavorite: _vm.clickFavorite,
                                          showCertificate: _vm.showCertificate
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.$q.platform.is.mobile
                                    ? _c("card-mobile", {
                                        key: course.id,
                                        attrs: { course: course },
                                        on: {
                                          clickLike: _vm.clickLike,
                                          clickStars: _vm.clickStars,
                                          clickFavorite: _vm.clickFavorite,
                                          showCertificate: _vm.showCertificate
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            }),
                            _vm.courses.length == 0 && !_vm.has_next_page
                              ? _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-12" },
                                  [
                                    _c(
                                      "q-card",
                                      [
                                        _c("q-card-title", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$t("no_course_found")
                                              ) +
                                              "\n                                    "
                                          )
                                        ]),
                                        _c("q-card-separator"),
                                        this.search ||
                                        this.selected_areas.length > 0 ||
                                        this.favorite != "all" ||
                                        this.progress != "all"
                                          ? _c("q-card-main", [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "searched_term_returned_no_results"
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ])
                                          : _c("q-card-main", [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "there_are_no_courses_avaliable_at_the_moment"
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "text-center q-mt-xl" },
                          [
                            _vm.has_next_page
                              ? _c("q-spinner-dots", {
                                  attrs: { slot: "message", size: 40 },
                                  slot: "message"
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c("modal-stars", {
        attrs: { show: _vm.show_modal, course: _vm.course },
        on: { hideModal: _vm.hideModal }
      }),
      _c("certificate", {
        attrs: {
          show: _vm.show_certificate,
          data: _vm.certificate_data,
          certificate: _vm.certificate
        },
        on: { hideCertificate: _vm.hideCertificate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }